import React from 'react';
import { setDash } from '../../../../../lib/common';
import InfoTable from '../../../../../components/table/InfoTable';
import './BrandDetailProductSummary.scss';

const BrandDetailProductSummary = (props) => {
  const { summaryInfo } = props;
  const {
    /**
     *  전체 상품 수
     */
    totalProductCount,
    /**
     *  승인대기 상품 수
     */
    permitWaitingCount,
    /**
     *  거절 상품 수
     */
    permitRejectedCount,
    /**
     *  품절된 상품 수
     */
    soldOutCount,
    /**
     *  판매중지된 상품 수
     */
    stoppedCount,
    /**
     *  삭제된 상품 수
     */
    deletedCount,
    /**
     *  판매중인 상품 수
     */
    saleingProductCount,
    /**
     *  판매중인 귀걸이 상품 수
     */
    earringCount,
    /**
     *  판매중인 목걸이 상품 수
     */
    necklaceCount,
    /**
     *  판매중인 반지 상품 수
     */
    ringCount,
    /**
     *  판매중인 팔찌 상품 수
     */
    braceletCount,
  } = summaryInfo;

  const etcCount = saleingProductCount - (earringCount + necklaceCount + ringCount + braceletCount);

  return (
    <div className="brand-detail-product-summary-content">
      {/* 전체 상품 정보 */}
      <div className="brand-detail-product-summary-section">
        <div className="title">전체 상품 정보</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc" colSpan={2}>
                전체 상품 수
              </td>
              <td className="tc" colSpan={2}>
                {setDash(totalProductCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                판매중인 상품 수
              </td>
              <td className="tc" colSpan={2}>
                {setDash(saleingProductCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                승인대기 상품 수
              </td>
              <td className="tc" colSpan={2}>
                {setDash(permitWaitingCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                거절 상품 수
              </td>
              <td className="tc" colSpan={2}>
                {setDash(permitRejectedCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                품절된 상품 수
              </td>
              <td className="tc" colSpan={2}>
                {setDash(soldOutCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                판매중지된 상품 수
              </td>
              <td className="tc" colSpan={2}>
                {setDash(stoppedCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                삭제된 상품 수
              </td>
              <td className="tc" colSpan={2}>
                {setDash(deletedCount)}
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>

      {/* 판매중인 상품 정보 */}
      <div className="brand-detail-product-summary-section">
        <div className="title">판매중인 상품 정보</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc" colSpan={2}>
                귀걸이 상품 수
              </td>
              <td className="tc" colSpan={2}>
                {setDash(earringCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                목걸이 상품 수
              </td>
              <td className="tc" colSpan={2}>
                {setDash(necklaceCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                반지 상품 수
              </td>
              <td className="tc" colSpan={2}>
                {setDash(ringCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                팔찌 상품 수
              </td>
              <td className="tc" colSpan={2}>
                {setDash(braceletCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                기타 상품 수
              </td>
              <td className="tc" colSpan={2}>
                {setDash(etcCount)}
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>
    </div>
  );
};

export default BrandDetailProductSummary;
